import { render, staticRenderFns } from "./SystemMemoryChart.vue?vue&type=template&id=14b55110&"
import script from "./SystemMemoryChart.vue?vue&type=script&lang=ts&"
export * from "./SystemMemoryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports